import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import LabTaskTable from '@app/components/apps/Labs&Research/LabTaskTable';

const breadcrumbMap: Record<string, string> = {
  REGULAR_TEST: 'Regular Test',
  AQO_INITIATED: 'AQO Initiated',
  BI_ANNUAL: 'Bi-Annual Test',
  DIRECT_SALES: 'Direct Sales',
  VACCINE_MANUFACTURING: 'Vaccine Manufacture',
  DISEASE_SURVEILLANCE: 'Disease Surveillance',
};

const AllLabTasks: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.replace('/', '');

  const labType = localStorage.getItem('selected_lab_type') || 'REGULAR_TEST';
  const breadcrumbName = breadcrumbMap[labType] || 'Labs & Research';

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: `/${currentPath}`, breadcrumbName: `Labs & Research - ${breadcrumbName}` }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Task',
      <BaseButton type="primary" size="small" onClick={() => navigate('/add-lab-task')}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [labType, setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Labs & Research</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <LabTaskTable />
        </Col>
      </Row>
    </>
  );
};

export default AllLabTasks;
